import get from "lodash/get"
import { darken, fade } from "@material-ui/core/styles/colorManipulator"
import { getLuminance } from "@material-ui/core/styles/colorManipulator"

function getTextContrastColor(color) {
    if(color){
    return (getLuminance(color) > 0.5) ? "#111111" : "rgb(255, 255, 255)"
    }
}

const styles = theme => {
    const primaryColor = get(theme, "appicalTheme.primary")
    return{
    loader: {
        position: "absolute",
        right: "8px",
    },

    base: {
        transition: "background-color 250ms, color 250ms, border-color 250ms",
        "border-radius": "20px",
        height: "40px",
        "min-width": "144px",
        padding: "4px 32px",
        "border-style": "solid",
        "border-width": "1px",
        "border-color": get(theme, "appicalTheme.black10"),
        "font-family": theme.typography.button.fontFamily,
        "font-size": theme.typography.button.fontSize,
        "font-weight": theme.typography.button.fontWeight,
        "line-height": theme.typography.button.lineHeight,
        "text-decoration": "none",
        "text-align": "center",
        color: "inherit",
        cursor: "pointer",
        position: "relative",
        outline: "none",
    },

    primary: {
        extend: "base",

        backgroundColor: get(theme, "appicalTheme.primary"),
        color: getTextContrastColor(primaryColor),

        "&:disabled": {
            opacity: "0.6",
            cursor: "not-allowed",
            backgroundColor: "transparent",
            color: `${get(theme, "appicalTheme.black")} !important`,
            borderColor: get(theme, "appicalTheme.black35"),
        },

        "&:hover:enabled": {
            backgroundColor: get(theme, "appicalTheme.primaryDark"),

            // Reset on touch devices
            "@media (hover: none)": {
                backgroundColor: get(theme, "appicalTheme.primary"),
            },
        },
        [theme.breakpoints.down("xs")]: {
            minWidth: "120px",
        },

        "&:hover:active:enabled": {
            backgroundColor: fade(get(theme, "appicalTheme.white", "#FFFFFF"), 0.2),
            color: get(theme, "appicalTheme.black70"),
            // borderColor: get(theme, "appicalTheme.black70"),
            border:" 1px solid #C0C0C0 "
        },

        "&:focus-visible": {
            outline: `2px solid rgba(0,0,0,1)`,
        },
    },

    secondary: {
        extend: "base",

        color: get(theme, "appicalTheme.primary"),
        backgroundColor: get(theme, "appicalTheme.white"),

        "&:disabled": {
            opacity: "0.5",
            cursor: "not-allowed",
            borderColor: `${get(theme, "appicalTheme.black20")} !important`,
            color: `${get(theme, "appicalTheme.black70")} !important`,
        },

        "&:hover:enabled": {
            backgroundColor: darken(get(theme, "appicalTheme.white", "#FFFFFF"), 0.12),

            // Reset on touch devices
            "@media (hover: none)": {
                backgroundColor: get(theme, "appicalTheme.white"),
            },
        },

        "&:hover:active:enabled": {
            backgroundColor: fade(get(theme, "appicalTheme.white", "#FFFFFF"), 0.2),
            color: get(theme, "appicalTheme.black70"),
            borderColor: get(theme, "appicalTheme.black70"),
        },
    },

    complete: {
        extend: "base",

        backgroundColor: get(theme, "appicalTheme.success"),
        color: get(theme, "appicalTheme.successText"),

        "border-width": "0px",
        "&:disabled": {
            opacity: "0.5",
            cursor: "not-allowed",
        },

        "&:hover:enabled": {
            backgroundColor: get(theme, "appicalTheme.successDark"),

            // Reset on touch devices
            "@media (hover: none)": {
                backgroundColor: get(theme, "appicalTheme.success"),
            },
        },

        "&:hover:active:enabled": {
            backgroundColor: fade(get(theme, "appicalTheme.white", "#FFFFFF"), 0.2),
            color: get(theme, "appicalTheme.black70"),
            borderColor: get(theme, "appicalTheme.black70"),
        },
    },

    contrast: {
        extend: "base",

        backgroundColor: get(theme, "appicalTheme.contrast"),
        color: get(theme, "appicalTheme.contrastText"),

        "&:disabled": {
            opacity: "0.5",
            cursor: "not-allowed",
        },

        "&:hover:enabled": {
            backgroundColor: get(theme, "appicalTheme.contrastDark"),

            // Reset on touch devices
            "@media (hover: none)": {
                backgroundColor: get(theme, "appicalTheme.contrast"),
            },
        },

        "&:hover:active:enabled": {
            backgroundColor: fade(get(theme, "appicalTheme.white", "#FFFFFF"), 0.2),
            color: get(theme, "appicalTheme.black70"),
            borderColor: get(theme, "appicalTheme.black70"),
        },
    },

    login: {
        extend: "base",

        backgroundColor: get(theme, "appicalTheme.loginButton"),
        color: get(theme, "appicalTheme.loginButtonText"),

        "&:disabled": {
            opacity: "0.7",
            cursor: "not-allowed",
        },

        "&:hover:enabled": {
            backgroundColor: get(theme, "appicalTheme.loginButtonDark"),
            // Reset on touch devices
            "@media (hover: none)": {
                backgroundColor: get(theme, "appicalTheme.loginButton"),
            },
        },

        "&:hover:active:enabled": {
            backgroundColor: fade(get(theme, "appicalTheme.white", "#FFFFFF"), 0.2),
            color: get(theme, "appicalTheme.black70"),
            borderColor: get(theme, "appicalTheme.black70"),
        },
    },

    resetPassword: {
        extend: "base",

        backgroundColor: get(theme, "appicalTheme.resetPasswordButton"),
        color: get(theme, "appicalTheme.resetPasswordButtonText"),

        "&:disabled": {
            opacity: "0.7",
            cursor: "not-allowed",
        },

        "&:hover:enabled": {
            backgroundColor: get(theme, "appicalTheme.resetPasswordButtonDark"),
            // Reset on touch devices
            "@media (hover: none)": {
                backgroundColor: get(theme, "appicalTheme.resetPasswordButton"),
            },
        },

        "&:hover:active:enabled": {
            backgroundColor: fade(get(theme, "appicalTheme.white", "#FFFFFF"), 0.2),
            color: get(theme, "appicalTheme.black70"),
            borderColor: get(theme, "appicalTheme.black70"),
        },
    },
}}

export default styles
